import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateStaffingSettings } from './update-staffing-settings.query';
export const { useSubscribableMutation: useSubscribableUpdateStaffingSettingsMutation, useSubscribeMutationResult: useSubscribableUpdateStaffingSettingsMutationResult, } = createSubscribableMutator(UpdateStaffingSettings);
/* createStatGuardedSubscribableMutator<UpdateStaffingSettingsMutation, UpdateStaffingSettingsMutationVariables>(
    UpdateStaffingSettings,
    'update',
    'staffLeaveSettingsV2',
); */
